import UserLayout from '../Layout/UserLayout'

export default function Survey() {
    return (
        <UserLayout>
            <h1 className='mb-3'>Settings: Report</h1>
            
        </UserLayout>
    )
}